import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Title } from '../Typography';

export const DrawerWrapper = tw.div`
  bg-white
  h-full
  fixed
  left-0
  top-header
  z-10
  w-0
  transition-all
  duration-500
  ease-in-out
  overflow-hidden
  main-category-nav
`;
export const SubNav = styled.div`
  overflow: auto;
  height: calc(100% - 80px);
`;
export const SecondaryNavWrapper = styled.div`
  overflow: auto;
  height: calc(100% - 120px);
`;
export const SecondarySubNav = styled.div``;
export const NavLink: any = tw(Title as any)`
  block
`;
export const CategoryList = styled.li`
  margin-left: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  display: none;
  .covert-red {
    background: red;
  }
  &:hover,
  &.selected-category {
    .category {
      font-weight: 600;
      transition: all 0.5s;
      &:before {
        content: '';
        position: absolute;
        display: block;
        width: 20px;
        border-bottom: 1px solid #5a5e5a;
        left: 0;
        top: 50%;
      }
    }
    .category-link {
      padding-left: 30px;
      &:after {
        content: '';
        width: calc(100% - 30px);
        left: 30px;
        position: absolute;
        bottom: 0;
        height: 1px;
        border-bottom: 1px solid;
        transition: all 0.5s;
      }
    }
  }

  @keyframes nav-enter {
    0% {
      margin-left: -200px;
      opacity: 0;
    }
    30% {
      margin-left: -100px;
      opacity: 0.7;
    }
    50% {
      margin-left: -50px;
      opacity: 0.7;
    }
    100% {
      margin-left: 0;
      opacity: 1;
    }
  }
`;
export const Texture = styled.div`
  &.texture-animation {
    animation: texture-enter 0.6s ease-in;
  }
  @keyframes texture-enter {
    0% {
      bottom: -300px;
    }
    50% {
      bottom: -150px;
    }
    100% {
      bottom: 4rem;
    }
  }
`;
export const textureStyle = 'relative left-0 h-72 w-full overflow-hidden asset-animation';
export const NavObject = tw.div`
  relative
  right-0
  bottom-0
  z-20
  w-full
`;
export const LinkContainer = styled.div`
  min-height: calc(100% - 388px);
`;
export const LintStyle = 'text-gray-500 mb-5 relative inline-block font-light category';
export const FeaturedLinkStyle =
  'text-gray-500 mb-5 relative inline-block font-light category feature-link';
export const openDrawerStyle =
  'w-sideNav 2xl:w-sideNav2XL 3xl:w-sideNav3XL transition-all duration-500 ease-in-out';

export const SubCategoryList = styled.li`
  margin-left: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  position: relative;
  &:hover {
    transition: all 0.5s;
    &:before {
      content: '';
      position: absolute;
      display: block;
      width: 20px;
      border-bottom: 1px solid #5a5e5a;
      left: 0;
      top: 30%;
      transition: all 0.5s;
    }
    .link-wrapper {
      padding-left: 30px;
      font-weight: 600;
      &:after {
        content: '';
        width: calc(100% - 30px);
        left: 30px;
        position: absolute;
        bottom: 0;
        height: 1px;
        border-bottom: 1px solid;
      }
    }
  }
`;

export const SecondaryDrawerWrapper = tw.div`
  bg-gray
  h-full
  fixed
  left-sideNav
  top-header
  z-10
  w-0
  transition-all
  duration-100
  ease-in-out
  overflow-x-hidden
  main-subcategory-nav
`;

export const SubLink = styled(Title)`
  &:before {
    width: 0px;
  }
`;

export const CardContainer = styled.div`
  .card-product {
    bottom: 157px;
  }
  .card-hovered {
    .card-product {
      bottom: 220px;
    }
  }
  .card-image {
    height: 239px;
    display: inline-block;
    flex: none;
  }
  .wrapper-link {
    width: 300px;
  }
`;
export const cardContainerStyle = 'w-72';
export const secondaryLinkStyle =
  'text-gray-500 mb-5 relative inline-block font-light link-wrapper';
export const openSecondaryDrawerStyle = 'w-secondaryNav transition-all duration-500 ease-in-out';
